import type { RouteName } from '@luminovo/design-system';
import { setAttribute, setTag } from '@sentry/react';

/**
 * Sentry's `url` and `transaction` carry the tenant subdomain and every UUID, so neither can rank pages.
 * `App.tsx` calls it at startup and as each load starts (`subscribeToRouteTag`).
 */
export const setSentryRouteTag = (routeName: RouteName | undefined): void => {
    // Tagged rather than skipped: it is the only way traffic to URLs no page claims shows up.
    const route = routeName ?? 'unmatched';
    setTag('route', route);
    // Spans take attributes only, and name a page load without a route Sentry knows `Pageload`.
    setAttribute('route', route);
};
